import React, {useState} from "react";
import MaskedInput from "react-text-mask";
import {connect} from "formik";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import {
    TextField, FormControl, InputLabel,
    OutlinedInput, InputAdornment, IconButton,
    FormHelperText
} from "@material-ui/core";
import AsyncSelect from "../Fields/AsyncSelect";
import InputCheckbox from "../Fields/Checkbox";
import {DateInput, TimeInput} from "../Fields/DateTime";
import TextArea from "../Fields/TextArea";


export const InputText = connect(({formik, name, className, label, ...fieldProps}) => (
    <TextField
        id={name}
        name={name}
        className={className}
        label={label}
        autoComplete='off'
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={() => formik.setFieldTouched(name, true)}
        error={formik.touched[name] && !!formik.errors[name]}
        helperText={formik.touched[name] && formik.errors[name]}
        variant="outlined"
        size="small"
        fullWidth
        {...fieldProps}
    />
));

export const InputNumber = connect(({formik, name, className, label, ...fieldProps}) => {
    return(
        <TextField
            id={name}
            name={name}
            className={className}
            label={label}
            autoComplete='off'
            value={formik.values[name]}
            onChange={e => formik.setFieldValue(name, e.target.value.replace(/\D/g, ''))}
            onBlur={() => formik.setFieldTouched(name, true)}
            error={formik.touched[name] && !!formik.errors[name]}
            helperText={formik.touched[name] && formik.errors[name]}
            variant="outlined"
            size="small"
            fullWidth
            {...fieldProps}
        />
    )
});

//formik.values[name] должно быть строкой
export const InputPrice = connect(({formik, name, className, label, ...fieldProps}) => (
    <TextField
        id={name}
        name={name}
        className={className}
        label={label}
        autoComplete='off'
        value={formik.values[name].replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')}
        onChange={e => formik.setFieldValue(name, e.target.value.replace(/^\.|[^\d.]|\.(?=.*\.)|^0+(?=\d)/g, ''))}
        onBlur={() => formik.setFieldTouched(name, true)}
        error={formik.touched[name] && !!formik.errors[name]}
        helperText={formik.touched[name] && formik.errors[name]}
        InputProps={{
            startAdornment: <InputAdornment position="start">₽</InputAdornment>
        }}
        variant="outlined"
        size="small"
        fullWidth
        {...fieldProps}
    />
));

export const InputPassword = connect(({formik, name, className, label, ...fieldProps}) => {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const error = formik.touched[name] && formik.errors[name];

    return (
        <FormControl className={className} variant="outlined" size="small" fullWidth {...fieldProps} error={!!error}>
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <OutlinedInput
                id={name}
                name={name}
                type={isShowPassword ? 'text' : 'password'}
                label={label}
                value={formik.values[name]}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched(name, true)}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setIsShowPassword(!isShowPassword)}
                            edge="end"
                        >
                            {isShowPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    )
});

const PhoneMaskCustom = ({inputRef, ...props}) => (
    <MaskedInput
        {...props}
        ref={ref => {
            inputRef(ref ? ref.inputElement : null);
        }}
        mask={['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
        guide={true}
        showMask={false}
    />
);

export const InputPhone = connect(({formik, name, className, label, ...fieldProps}) => {
    const error = formik.touched[name] && formik.errors[name];

    return (
        <FormControl className={className} variant="outlined" size="small" fullWidth {...fieldProps} error={!!error}>
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <OutlinedInput
                id={name}
                name={name}
                label={label}
                autoComplete='off'
                value={formik.values[name]}
                onChange={formik.handleChange}
                onBlur={() => {
                    formik.setFieldTouched(name, true);
                }}
                inputComponent={PhoneMaskCustom}
            />
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    )
});

export const FormikInputCheckbox = connect(({formik, name, className, label, disabled}) => (
    <InputCheckbox
        name={name}
        className={className}
        label={label}
        value={formik.values[name]}
        error={formik.touched[name] && formik.errors[name]}
        disabled={disabled}
        onChange={e => {
            formik.setFieldTouched(name, true);
            formik.handleChange(e);
        }}
    />
));

export const FormikTextArea = connect(({formik, name, className, label, ...fieldProps}) => (
    <TextArea
        name={name}
        className={className}
        label={label}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={() => formik.setFieldTouched(name, true)}
        error={formik.touched[name] && !!formik.errors[name]}
        helperText={formik.touched[name] && formik.errors[name]}
    />
));

export const FormikAsyncSelect = connect(({formik, name, className, label, url, multiple = false, disableClearable = false}) => (
    <AsyncSelect
        id={name}
        name={name}
        className={className}
        label={label}
        url={url}
        multiple={multiple}
        disableClearable={disableClearable}
        value={formik.values[name]}
        onChange={value => formik.setFieldValue(name, value)}
        onBlur={() => formik.setFieldTouched(name, true)}
    />
));

export const FormikDateInput = connect(({formik, name, className, label, maxDate, minDate}) => (
    <DateInput
        name={name}
        className={className}
        label={label}
        maxDate={maxDate}
        minDate={minDate}
        value={formik.values[name]}
        onChange={date => formik.setFieldValue(name, date)}
        onBlur={() => formik.setFieldTouched(name, true)}
        error={formik.touched[name] && !!formik.errors[name]}
        helperText={formik.touched[name] && formik.errors[name]}
    />
));

export const FormikTimeInput = connect(({formik, name, className, label}) => (
    <TimeInput
        name={name}
        className={className}
        label={label}
        value={formik.values[name]}
        onChange={date => formik.setFieldValue(name, date)}
        onBlur={() => formik.setFieldTouched(name, true)}
        error={formik.touched[name] && !!formik.errors[name]}
        helperText={formik.touched[name] && formik.errors[name]}
    />
));